import { NotFoundError } from '@tanstack/react-router'

import { InfoCard } from '@postxl/ui-components'

export const NotFoundErrorPage = ({ error }: { error: NotFoundError }) => {
  console.log(error)
  return (
    <InfoCard
      variant="not-found"
      title="Page Not Found"
      message="The page you're looking for doesn't exist."
      showHomeButton
    />
  )
}
